import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosIntance,{fetchInstance} from '../../helper/axios'
import { useHistory } from "react-router-dom";
import ReactDOM from 'react-dom';
import './firstmile.css';
import MaterialTable from "material-table";
import Sidebar from '../Template/Sidebar/Sidebar';
import Header from '../Template/Header/Header';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import {baseUrl} from '../../config';
import {clickColor,inArray} from './../../library/util';
import Loader from "react-loader-spinner";
function Firstmile() {
    console.log('firstmile')
    const [selectedRow, setSelectedRow] = useState(null);
    const history = useHistory();
    const [loader,setLoader]=useState(false)

    const [selectedrowList,setSelectedRowList]=useState([]);


 const setRowBackground = (selectedRow)=>{
        if(inArray(selectedRow.tableData.id,selectedrowList)==false){ 
        setSelectedRowList(oldArray => [...oldArray,selectedRow.tableData.id] );
        setSelectedRow(selectedRow.tableData.id)
        console.log(selectedrowList)
        }else{    
          setSelectedRow(500000)
          setSelectedRowList([])
        }
      }
    checkUserTypeFn(history);

function checkUserTypeFn(history){
  const userdata=JSON.parse(localStorage.getItem('userdata'));
  const usertype=userdata.type;
  console.log('in check usertype fn');
  console.log(usertype)
  if(usertype!='admin' && usertype!='superadmin' && usertype!='subadmin' && usertype!='databasehelper' && usertype!='owneradmin'){
    history.push('/');
 }
}
  
    const handleSignOut = () => {
        console.log('logout')
        window.localStorage.setItem('isLogin',false);
        history.push('/');
      }
    
      if(localStorage.getItem('isLogin')==="false" || localStorage.getItem('isLogin')==null){
        history.push('/');
      }
    const [cssCodesData,setcssCodesData]=useState([])
  
    const [message, setMessage] = useState('')
    const [successMsg,setSuccessMsg]=useState('')
    const [resultCount,setResultCount]=useState(0);
    const [resultCountCounter,setResultCountCounter]=useState(0);
    const data = [['attribute', 'attribute2'], ['value1', 'value2']];

    useEffect(() => {
      setLoader(true)
      axiosIntance.get(baseUrl+'/count/firstmile', {}).then(response => {
        console.log('resultCount='+response.data.result);
        setResultCount(response.data.result);
        setResultCountCounter(1);
        setLoader(false)
      }).catch(error => {
        console.log(error)
        setMessage('Something went wrong');
      });
  
  
      return () => {
        console.log('un subscribe')
      }
  
  
  
    }, [])

      const SubmitDelete = (e) => {

        confirmAlert({
          title: '',
          message: 'Are you sure want to delete All data',
          buttons: [
            {
              label: 'Yes',
              onClick: () => 
              axiosIntance.delete(baseUrl+'/firstmile', {}).then(response => {
                setSuccessMsg('Deleted!')
               // setTimeout(()=>window.location.href = '/viewFirstmile',2000)
              }).catch(error => {
                setMessage('Something went wrong');
              })
    
            },
            {
              label: 'No',
              onClick: () => console.log('No')
            }
          ]
        });
      }
    return (
        <div id="wrapper" className>
      <Sidebar />
      <Header handleSignOut={handleSignOut} />


    <div className='delete-div'>
      {
        resultCount>0 ?  <button type="button"  onClick={SubmitDelete} className="btn btn-primary">Delete All </button>:''
       
      }
     
    </div>
    <div className='errorMsg'>{message}</div>
    <div className='successMsg viewScreen'>{successMsg}</div>


      <section id="content-wrapper">

      {loader &&
    <div className='loaderDiv'>  
        <Loader
              type="Circles"
              color="#b4d6fa"
              height={100}
              width={100}
              //timeout={1000} //3 secs
          />
    </div> 
    }
      {resultCountCounter>0 && 
        <MaterialTable
        // onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}

        onRowClick={((evt, selectedRow) => 
          setRowBackground(selectedRow)
          )}


          columns={[
            { title: "invoice_date", field: "invoice_date" },
            { title: "invoice_number", field: "invoice_number" },
            { title: "pickup_date", field: "pickup_date" },
            { title: "tracking_number", field: "tracking_number" },
            { title: "total_charge", field: "total_charge" },
            { title: "product_1", field: "product_1" },
            { title: "product_2", field: "product_2" },
            { title: "label_number", field: "label_number" },
            { title: "fm_base_rate", field: "fm_base_rate" },
            { title: "zone", field: "zone" },
            { title: "weight_oz", field: "weight_oz" },
            { title: "weight_lbs", field: "weight_lbs" },
            { title: "billing_ref", field: "billing_ref" },
            { title: "billing_ref2", field: "billing_ref2" },

            { title: "recipient_name", field: "recipient_name" },
            { title: "recipient_address", field: "recipient_address" },
            { title: "recipient_address2", field: "recipient_address2" },
            { title: "recipient_city", field: "recipient_city" },
            { title: "recipient_state", field: "recipient_state" },

            { title: "recipient_country", field: "recipient_country" },
            { title: "recipient_zip", field: "recipient_zip" },

            { title: "fuel", field: "fuel" },
            { title: "surcharge_1_type", field: "surcharge_1_type" },
            { title: "surcharge_1", field: "surcharge_1" },

            { title: "surcharge_2_type", field: "surcharge_2_type" },
            { title: "surcharge_2", field: "surcharge_2" },


            { title: "surcharge_3_type", field: "surcharge_3_type" },
            { title: "surcharge_3", field: "surcharge_3" },

            { title: "surcharge_4_type", field: "surcharge_4_type" },
            { title: "surcharge_4", field: "surcharge_4" },

            { title: "surcharge_5_type", field: "surcharge_5_type" },
            { title: "surcharge_5", field: "surcharge_5" },

            { title: "surcharge_6_type", field: "surcharge_6_type" },
            { title: "surcharge_6", field: "surcharge_6" },

            { title: "surcharge_7_type", field: "surcharge_7_type" },
            { title: "surcharge_7_type", field: "surcharge_7_type" },

            { title: "surcharge_8_type", field: "surcharge_8_type" },
            { title: "surcharge_8", field: "surcharge_8" },

            { title: "surcharge_9_type", field: "surcharge_9_type" },
            { title: "surcharge_9", field: "surcharge_9" },

            { title: "surcharge_10_type", field: "surcharge_10_type" },
            { title: "surcharge_10", field: "surcharge_10" },


            { title: "surcharge_11_type", field: "surcharge_11_type" },
            { title: "surcharge_11", field: "surcharge_11" },


            { title: "surcharge_12_type", field: "surcharge_12_type" },
            { title: "surcharge_12", field: "surcharge_12" },

            { title: "surcharge_13_type", field: "surcharge_13_type" },
            { title: "surcharge_13", field: "surcharge_13" },


            { title: "surcharge_14_type", field: "surcharge_14_type" },
            { title: "surcharge_14", field: "surcharge_14" },


            { title: "surcharge_15_type", field: "surcharge_15_type" },
            { title: "surcharge_15", field: "surcharge_15" },


            { title: "surcharge_16_type", field: "surcharge_16_type" },
            { title: "surcharge_16", field: "surcharge_16" },

            { title: "surcharge_17_type", field: "surcharge_17_type" },
            { title: "surcharge_17", field: "surcharge_17" },

            { title: "surcharge_18_type", field: "surcharge_18_type" },
            { title: "surcharge_18", field: "surcharge_18" },

            { title: "surcharge_19_type", field: "surcharge_19_type" },
            { title: "surcharge_19", field: "surcharge_19" },

            { title: "surcharge_20_type", field: "surcharge_20_type" },
            { title: "surcharge_21", field: "surcharge_21" },
            { title: "surcharge_22_type", field: "surcharge_22_type" },
            { title: "surcharge_22", field: "surcharge_22" },

            { title: "surcharge_23_type", field: "surcharge_23_type" },
            { title: "surcharge_23", field: "surcharge_23" },

            { title: "surcharge_24_type", field: "surcharge_24_type" },
            { title: "surcharge_24", field: "surcharge_24" },

            { title: "surcharge_25_type", field: "surcharge_25_type" },
            { title: "surcharge_25", field: "surcharge_25" },

            { title: "surcharge_26_type", field: "surcharge_26_type" },
            { title: "surcharge_26", field: "surcharge_26" },

            { title: "surcharge_27_type", field: "surcharge_27_type" },
            { title: "surcharge_27", field: "surcharge_27" },

          



            { title: "dim_length", field: "dim_length" },
            { title: "dim_width", field: "dim_width" },

            { title: "dim_height", field: "dim_height" },
            { title: "actual_weight", field: "actual_weight" },
           


       





         



          






          
            
            
           
          ]}
          data={query =>
            new Promise((resolve, reject) => {
              // console.log(query)
           
              let url = baseUrl+'/firstmile?'
              url += `&_page=${query.page + 1}`
              url += `&_limit=${query.pageSize}`
              fetchInstance(url)
                .then(response => response.json())
                .then(result => {
                  // console.log('promise result'+resultCount)
                   console.log(result)
                 
                 
                  resolve({
                    data: result.result,
                    page: query.page,
                    totalCount: resultCount,
                  })
                })
            })
          }
        
          options={{
            sorting: false,
            search: false,
            loadingType: 'overlay',
            // headerStyle: { fontSize:'15px',fontWeight:'bold' },
            maxBodyHeight: '500px',
            headerStyle: { position: 'sticky', top: 0,fontSize:'17px',fontWeight:'bold' },
            rowStyle: rowData => ({
              backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
            })
          }}
          title="Firstmile"
        />
      }
      </section>
    </div>
    )
}

export default Firstmile
